import { useSelector } from 'react-redux'

import { selectSnackbar } from 'redux/selectors/Snackbar'

export const useSnackbar = () => {
  return useSelector(selectSnackbar)
}
